"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.onCreateNewCodingEntry = void 0;
const pino_1 = __importDefault(require("pino"));
const strings_1 = require("../../../../../constants/strings");
const logger = (0, pino_1.default)();
const onCreateNewCodingEntry = ({ selectedCodingList, newCodingEntry, saveCodingListEntry, toggleCodingListEntryQuery, newCodingEntryTeams, setNewCodingEntry, setCurrentSelectedCodingEntry, company, setNotification, }) => {
    if (newCodingEntry.ID && newCodingEntry.path) {
        saveCodingListEntry.mutate({
            codingListCode: selectedCodingList.id,
            codingEntryId: newCodingEntry.ID,
            codingEntryLabel: newCodingEntry.path,
        }, {
            onSuccess: () => {
                setNotification([
                    {
                        type: strings_1.notificationStrings.SUCCESS,
                        message: strings_1.companySettingsCodingStrings.CODING_ENTRY_SAVE_SUCCESS,
                    },
                ]);
                setNewCodingEntry({ ID: '', path: '' });
            },
            onError: error => {
                logger.error({ error });
                setNotification([
                    {
                        type: strings_1.notificationStrings.ERROR,
                        message: strings_1.companySettingsCodingStrings.CODING_ENTRY_SAVE_ERROR,
                    },
                ]);
            },
        });
        if (newCodingEntryTeams && newCodingEntryTeams.length > 0) {
            // this when we change the team selection
            newCodingEntryTeams.forEach((entry) => {
                toggleCodingListEntryQuery.mutate({
                    codingListCode: selectedCodingList.id,
                    codingEntryId: newCodingEntry.ID,
                    teamId: entry.teamId,
                    state: entry.state,
                    companyId: company.companyId,
                }, {
                    onSuccess: () => {
                        setNotification([
                            {
                                type: strings_1.notificationStrings.SUCCESS,
                                message: strings_1.companySettingsCodingStrings.CODING_ENTRY_SAVE_SUCCESS,
                            },
                        ]);
                        setNewCodingEntry({ ID: '', path: '' });
                        setCurrentSelectedCodingEntry({ ID: '', path: '' });
                    },
                    onError: error => {
                        logger.error({ error });
                        setNotification([
                            {
                                type: strings_1.notificationStrings.ERROR,
                                message: strings_1.companySettingsCodingStrings.CODING_ENTRY_SAVE_ERROR,
                            },
                        ]);
                    },
                });
            });
        }
    }
};
exports.onCreateNewCodingEntry = onCreateNewCodingEntry;
